/**
 * 认证信息
 * 只保存基本信息，不作 http 调用
 */
import { defineStore } from 'pinia'
import { isWechat } from '@/utils/utils.js'


export const useAuthStore = defineStore(
  'auth',
  () => {
    const accessToken = ref() // 当前帐户  token
    const token = ref() // 当前帐户  token
    const refreshToken = ref() // 
    const isLogin = ref(false) // 
    const isBindingWechat = ref(isWechat()) // 是否绑定公众号
    const code = ref('') // 
    const redirect = ref() // 
    const phone = ref('') // 
    const uid = ref('') // 

    // logout
    function logoutRmToken() {
      accessToken.value = ''
      token.value = ''
      refreshToken.value = ''
      phone.value = ''
      uid.value = ''
      isLogin.value = false
      isBindingWechat.value = isWechat() ? false : null
    }

    function saveAuth(data) {
      accessToken.value = data.accessToken
      token.value = data.accessToken
      data.refreshToken && (refreshToken.value = data.refreshToken)
      data.phone && (phone.value = data.phone)
      uid.value = data.uid || data.id
      isLogin.value = true
    }

    return {
      accessToken, refreshToken, isLogin, token, phone, uid,
      code, redirect, isBindingWechat,
      logoutRmToken, saveAuth,
    }
  },
  {
    persist: [
      {
        paths: ['accessToken', 'refreshToken', 'token', 'redirect', 'phone', 'uid', 'isBindingWechat'],
        storage: localStorage,
      },
      {
        paths: ['isLogin', 'code'],
        storage: sessionStorage,
      },
    ],
    // true,  // default localStorage
    // persist: { key: 'store:app', } // default $id
  }
)